export const checkIsDomainInvalid = (domain?: string) => {
  if (!domain?.trim()) return 'Must include an email domain';
  if (/\s/.test(domain)) return 'Domain cannot contain spaces';
  // \p{L} matches any Unicode letter so IDN TLDs (e.g. .рф, .中国, .한국) validate.
  const extensionMatch = domain.match(/\.(\p{L}+)$/u);
  if (!extensionMatch) {
    return "Please include an extension e.g. '.com'";
  }
  if (extensionMatch[1].length > 24) {
    return 'Extension is too long';
  }
  if (extensionMatch[1].length < 2) {
    return "Please include an extension e.g. '.com'";
  }
  return '';
};
